export const queryTypes = {
  FULL: 'full',
  CART_COUNT: 'cart_count'
}
